export * from './lib/ProductDetailsContainer';
export { getProductGroupConfigByKey, isValidProductGroupKey } from './lib/productGroups';
export { getSavingsAmountInCents } from './lib/productSavingsAmounts';
export { getDesignInspiration } from './util/getDesignInspiration';
export { getRelatedProductsByProductGroupKey } from './util/getRelatedProductsByProductGroupKey';
export { getPageConfigFromContentful } from './util/getPageConfigFromContentful';
export { getProductsByProductGroupName } from './util/getProductsByProductGroupName';

export type {
    ContestProduct,
    ContestProductGroupKey,
    ContestProductGroupName,
    FixedPriceProjectProduct,
    ProductGroup,
    ProductGroupKey,
    RelatedProduct,
    ProductGroupName,
} from './types';
export type { ProductDetailsInspirationQuery } from './util/getDesignInspiration';
